import { useCallback } from "react";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";
import { renderActions, selectSavedCameraPositions, selectViewMode } from "features/render";
import { ViewMode } from "types/misc";

export function useStepForwards() {
    const savedCameraPositions = useAppSelector(selectSavedCameraPositions);
    const viewMode = useAppSelector(selectViewMode);
    const canStepForwards =
        savedCameraPositions.currentIndex < savedCameraPositions.positions.length - 1 && viewMode !== ViewMode.Panorama;
    const dispatch = useAppDispatch();

    const stepForwards = useCallback(() => {
        const step = savedCameraPositions.positions[savedCameraPositions.currentIndex + 1];

        if (!step) {
            return;
        }

        dispatch(renderActions.redoCameraPosition());
    }, [savedCameraPositions, dispatch]);

    return { stepForwards, canStepForwards };
}
